import Cart from './Cart'
import Overview from './Overview'
import Payment from './Payment'
import Register from './Register'
import Shipping from './Shipping'
import User from './User'

export default {
  Cart,
  Overview,
  Payment,
  Register,
  Shipping,
  User
}

export const RegistrationType = {
  USER: 1,
  GUEST: 2
}

export const UserType = {
  PERSON: 1,
  COMPANY: 2
}
